import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-83a9635c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title-bar" }
const _hoisted_2 = { class: "access-body" }
const _hoisted_3 = { class: "setting-unit" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "description-wrapper" }
const _hoisted_6 = { class: "description" }
const _hoisted_7 = { class: "description-wrapper" }
const _hoisted_8 = { class: "description" }
const _hoisted_9 = { class: "setting-unit" }
const _hoisted_10 = { class: "title" }
const _hoisted_11 = { class: "description-wrapper" }
const _hoisted_12 = { class: "description" }
const _hoisted_13 = { class: "description-wrapper" }
const _hoisted_14 = { class: "description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_bottom_pop_up_item = _resolveComponent("bottom-pop-up-item")!
  const _component_app_bottom_pop_up = _resolveComponent("app-bottom-pop-up")!

  return (_openBlock(), _createBlock(_component_app_bottom_pop_up, {
    onHide: _ctx.hidePopUp,
    "hide-bottom-decoration": "",
    "hide-top-decoration": ""
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, _toDisplayString(_ctx.$localize('messaging.settings.title')), 1),
        _createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hidePopUp && _ctx.hidePopUp(...args))),
          href: "#",
          class: "done-btn"
        }, _toDisplayString(_ctx.$localize('share.by.message.popup.button')), 1)
      ])
    ]),
    body: _withCtx(() => [
      _createVNode(_component_bottom_pop_up_item, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$localize('share.by.message.popup.resharing.title')), 1),
              _createVNode(_component_el_radio_group, {
                modelValue: _ctx.sharingSettings.allowedResharing,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.sharingSettings.allowedResharing) = $event)),
                onChange: _ctx.dummyResharingValueChange
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, { label: true }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$localize('share.by.message.popup.resharing.allow')), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, { label: false }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$localize('share.by.message.popup.resharing.not.allow')), 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$localize('share.by.message.popup.saving.title')), 1),
              _createVNode(_component_el_radio_group, {
                modelValue: _ctx.sharingSettings.allowedSave,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.sharingSettings.allowedSave) = $event)),
                onChange: _ctx.dummySaveValueChange
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, { label: true }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$localize('share.by.message.popup.save.allow')), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, { label: false }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$localize('share.by.message.popup.save.not.allow')), 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onHide"]))
}